import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  videoFolderActions,
  videoFolderSelectors
} from '../../../../store/modules/videoFolder';

const useProjectDraftStatusUpdate = () => {
  const dispatch = useDispatch();
  const currentFolderId = useSelector(
    videoFolderSelectors.selectCurrentFolderId
  );

  useEffect(() => {
    if (!currentFolderId) return;

    dispatch(videoFolderActions.updateProjectAllStatuses());
  }, [currentFolderId]);
};

export default useProjectDraftStatusUpdate;
